@if (spinner.loading() === true) {
<div class="spinner-overlay" data-testid="spinner-overlay">
  <div class="spinner-ring"></div>
</div>
}
